import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './TextWithParsedLinks.styled';

// const getLink = (text) => {
//   (http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])
// }

const TextWithParsedLinks = ({ text, contrast }) => {
  const parsedTextArray = useMemo(() => {
    const parsed = text.replaceAll('\n', ' ').split(' ');
    return parsed;
  }, [text]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
  }, []);
  return (
    <>
      {parsedTextArray.map((slice, index) => {
        if (
          slice.indexOf('http://') === 0 ||
          slice.indexOf('https://') === 0 ||
          slice.indexOf('www.') === 0
        ) {
          const href = slice.indexOf('www.') === 0 ? `https://${slice}` : slice;
          return (
            <Styled.ParsedLink
              key={index}
              $contrast={contrast}
              onClick={handleClick}
              rel="noreferrer"
              target="_blank"
              href={href}
            >
              {slice + ' '}
            </Styled.ParsedLink>
          );
        }
        return <React.Fragment key={index}>{slice + ' '}</React.Fragment>;
      })}
    </>
  );
};

TextWithParsedLinks.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TextWithParsedLinks;
